var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgGoogleAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9AB00",
    d: "M14 2.625v16.5C14 20.971 15.214 22 16.5 22c1.19 0 2.5-.875 2.5-2.875V2.75C19 1.058 17.81 0 16.5 0S14 1.166 14 2.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E37400",
    d: "M7 11.505C7 10.113 8.19 9 9.5 9s2.5 1.009 2.5 2.624v7.633C12 21.165 10.69 22 9.5 22 8.214 22 7 21.018 7 19.257v-7.752zM2.5 22a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default ForwardRef;